import RecoveryPassword from "./recoveryPassword";

export default RecoveryPassword;
